// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"G1-z","displaySixCardTiles":"H1-z"};